import { wf } from './shell/tokens';

export type FleetStage =
  | 'awaiting_verification'
  | 'intake_incomplete'
  | 'credentialing_in_progress'
  | 'ehr_in_progress';

export const FLEET_STAGE_TILES: {
  value: FleetStage | null;
  label: string;
  hint: string;
  color: string;
  adminOnly?: boolean;
}[] = [
  {
    value: null,
    label: 'All practices',
    hint: 'With intake activity in this search',
    color: wf.ink,
  },
  {
    value: 'awaiting_verification',
    label: 'Awaiting verification',
    hint: 'Intake submitted, not yet reviewed',
    color: wf.amber,
    adminOnly: true,
  },
  {
    value: 'intake_incomplete',
    label: 'Intake incomplete',
    hint: 'Waiting on the practice',
    color: wf.slate,
    adminOnly: true,
  },
  {
    value: 'credentialing_in_progress',
    label: 'Credentialing in progress',
    hint: 'Provider × payer entries still being worked',
    color: wf.blue,
  },
  {
    value: 'ehr_in_progress',
    label: 'Migration in progress',
    hint: 'EHR files importing or awaiting review',
    color: wf.blue,
  },
];

/** The stage from a URL value, when it exists and this viewer may filter by it. */
export function allowedFleetStage(value: string | null, canVerify: boolean): FleetStage | null {
  const tile = FLEET_STAGE_TILES.find(item => item.value !== null && item.value === value);
  return tile?.value && (canVerify || !tile.adminOnly) ? tile.value : null;
}
